import React from 'react';

import { Spinner } from '../../../Spinner';

import styles from './FetchingOverlay.module.scss';

export interface IFetchingOverlayProps {}

export const FetchingOverlay: React.FC<IFetchingOverlayProps> = () => {
    return (
        <div className={styles.fetchingOverlay}>
            <div className={styles.wrapper}>
                <Spinner fullScreen />
            </div>
        </div>
    );
};
